<template>
    <div
        v-if="showButtonsBanner"
        class="bg-white pc-button-banner border p-1 shadow w-100 d-flex align-items-center">
        <slot />
    </div>
</template>

<script>
    export default {
        data() {
            // this.$slots.default points to the render function, so check if the rendered content
            // has child content
            const defaultContent = this.$slots.default ? this.$slots.default() : null;
            return {
                showButtonsBanner:
                    defaultContent && defaultContent.length > 0 ? defaultContent[0]?.children?.length > 0 : false
            };
        }
    };
</script>

<style lang="scss" scoped>
    // m-1 + p-2 + m-2 + 1.5 rem, matches navSidebar's chevron wrapper
    $banner-height: 4rem;

    .pc-button-banner {
        min-height: $banner-height;
        height: $banner-height;
    }
</style>
